import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, useTheme } from '@mui/material';
import { clearIcon, notClearIcon } from '../../../../assets/icons';
import { Player } from '../../../../state/reduxRepositories/players/player.interfaces';

interface TeamSummaryStatsProps {
  cleared: number;
  notCleared: number;
  teamPlayers: Player[];
}

export const TeamSummaryStats = ({
  cleared,
  notCleared,
  teamPlayers,
}: TeamSummaryStatsProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <Grid>
      {teamPlayers?.length > 0 && cleared === teamPlayers?.length && (
        <Grid
          item
          display="flex"
          alignItems="center"
          columnGap={1}
          sx={{ color: theme.palette.text.primary }}
        >
          {clearIcon}
          {t('ALL_PLAYERS_CLEAR')}
        </Grid>
      )}
      {teamPlayers?.length > 0 && notCleared === teamPlayers?.length && (
        <Grid
          item
          display="flex"
          alignItems="center"
          columnGap={1}
          sx={{ color: theme.palette.text.primary }}
        >
          {notClearIcon}
          {t('ALL_PLAYERS_NOT_CLEAR')}
        </Grid>
      )}
      {cleared > 1 && cleared !== teamPlayers?.length && (
        <Grid
          item
          display="flex"
          alignItems="center"
          columnGap={1}
          sx={{ color: theme.palette.text.primary }}
        >
          {clearIcon}
          {t('TEAM_PLAYERS_N_CLEAR', { count: cleared })}
        </Grid>
      )}
      {notCleared > 1 && notCleared !== teamPlayers?.length && (
        <Grid
          item
          display="flex"
          alignItems="center"
          columnGap={1}
          sx={{ color: theme.palette.text.primary }}
        >
          {notClearIcon}
          {t('TEAM_PLAYERS_N_NOT_CLEAR', { count: notCleared })}
        </Grid>
      )}
      {cleared === 1 && cleared !== teamPlayers?.length && (
        <Grid
          item
          display="flex"
          alignItems="center"
          columnGap={1}
          sx={{ color: theme.palette.text.primary }}
        >
          {clearIcon}
          {t('TEAM_PLAYERS_1_CLEAR', { count: cleared })}
        </Grid>
      )}
      {notCleared === 1 && notCleared !== teamPlayers?.length && (
        <Grid
          item
          display="flex"
          alignItems="center"
          columnGap={1}
          sx={{ color: theme.palette.text.primary }}
        >
          {notClearIcon}
          {t('TEAM_PLAYERS_1_NOT_CLEAR', { count: notCleared })}
        </Grid>
      )}
    </Grid>
  );
};
